import React from "react";
import { BEM, T, useTranslate } from "@adapptio/lib-components";
import { capitalizeFirstLetter, isObject } from "@adapptio/lib-shared";
import { Badge, BADGE_POSITION } from "../../../../../ui/components/Badge";
import { Markdown } from "../../../../../ui/components/Markdown";
import { TabsEditor } from "../TabsEditor/TabEditor";
import { ChildItem } from "./ReferenceGuideChild";

export const ParentContent = ({ data, view }) => {
	const t = useTranslate();

	const baseClass = BEM("edt-reference-guide-main");

	return (
		<div className={baseClass.element("section").toClassName()}>
			<h2>{data.childType}</h2>
			{data.child.map((item, index) => {
				const type = capitalizeFirstLetter(item?.type);

				if (isNaN(index)) {
					return;
				}

				if (item?.label) {
					return (
						<div key={index} id={index} className={baseClass.element("element").toClassName()}>
							<div className={baseClass.element("item-head").toClassName()}>
								<h4>
									{item.required && (
										<>
											<T domain="editor" term={item.label} /> : {type}
										</>
									)}
									{!item.required && (
										<Badge position={BADGE_POSITION.END} content="nullable">
											<T domain="editor" term={item.label} /> : {type}
										</Badge>
									)}
								</h4>
								<hr />
							</div>
							<div className={baseClass.element("item-content").toClassName()}>
								<div>
									<Markdown>{t("editor", item.description)}</Markdown>

									{!!item.defaultValue &&
										(isObject(item.defaultValue) ? (
											<div
												className={baseClass.element("values-default").toClassName()}
											>
												<div>
													<p>Default value:</p>
												</div>
												<div>
													<ul>
														{Object.keys(item.defaultValue).map(
															(itemDefault, idx) => (
																<li key={idx}>
																	<b>
																		{itemDefault}:{" "}
																		{item.defaultValue[itemDefault]}
																	</b>
																</li>
															)
														)}
													</ul>
												</div>
											</div>
										) : (
											<div
												className={baseClass.element("values-default").toClassName()}
											>
												<div>
													<p>Default value:</p>
													<b>
														<Markdown>{t("editor", item.defaultValue)}</Markdown>
													</b>
												</div>
											</div>
										))}

									{item.options && (
										<div className={baseClass.element("values").toClassName()}>
											<div>
												<p>Values:</p>
											</div>
											<div>
												<ul>
													{item.options.map((item, idx) => (
														<li key={idx}>
															<b>
																<T domain="editor" term={item.value} />
															</b>
														</li>
													))}
												</ul>
											</div>
										</div>
									)}
								</div>
								<div>
									{item.descriptor && (
										<TabsEditor descriptor={item.descriptor} examples={item.examples} />
									)}
								</div>
							</div>
							{!!item.child?.length &&
								item.child.map((childItem, childIndex) => {
									const breadcrumbs = [ item.label ];
									if (childItem) {
										return (
											<ChildItem
												key={childItem.label + String(childIndex)}
												data={childItem}
												breadcrumbs={breadcrumbs}
												view={view}
												parentIdx={index}
												idx={childIndex}
											/>
										);
									}
								})}
						</div>
					);
				}
			})}
		</div>
	);
};
